import styles from 'styles/add/FlexRow.module.css'

const FlexRow = ({ children, inner, wrap }) => (
    <div className={inner
        ? styles.inner
        : styles.outer} wrap={wrap && 'true'}>

        {children}
    </div>
)

export default FlexRow

